import {
  Box,
  Theme,
  useMediaQuery,
  useTheme,
  Typography,
  styled,
  Backdrop,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
// import { DesktopLoginBg, dskLogo, LoginBg, Logo } from "../../Assets";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router-dom";
import {
  adminTeamBg,
  auctionBg,
  headerBadge,
  mcaI20Logo,
  mcaLogo,
} from "../../../Assets";
import routes from "../../../Utils/routes";
import { positions } from "@mui/system";
import { formatPathToTitle } from "../../../Utils/helperFunctions";

interface ReactChildren {
  children: React.ReactNode;
}

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100dvh",
    width: "100%",
    position: "relative",
    backgroundColor: "#101010",
    fontFamily: "Schibsted Grotesk !important",
    // backgroundImage: `url(${LoginBg}) !important`,
    backgroundSize: "cover",
    overflow: "hidden",
  },
  desktopLayout: {
    height: "100vh",
    position: "relative",
    backgroundColor: "#0D0D0D",
    padding: "36px",
  },
  desktopHeader: {
    height: "80px",
    backgroundColor: "#161616",
    borderRadius: "12px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopHeaderContainer: {
    width: "95%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopContainer: {
    backgroundSize: "cover",
    width: "100%",
    height: "calc(100vh - 152px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "36px",
  },
  mobileScreen: {
    height: "calc(100% - 32px)",
    width: "calc(100% - 32px)",
    position: "relative",
    padding: "16px",
  },
  desktopScreen: {
    height: "100%",
    width: "100%",
    overflowY: "scroll",
    // overflowX: "hidden",
  },
  adminDesktopScreen: {
    height: "calc(100% - 32px)",
    width: "100%",
    overflowY: "scroll",
    borderRadius: "12px",
    backgroundImage: `url(${adminTeamBg}) !important`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    // overflowX: "hidden",
  },
  formContainer: {
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100% !important",
    minHeight: "100vh !important",
    width: "100% !important",
    alignItems: "center",
  },
  copywrite: {
    fontSize: "14px !important",
    fontWeight: "500",
    color: "#8A8A8A",
    [theme.breakpoints.down("ultraHD")]: {
      fontSize: "10.5px !important",
    },
  },
  loginVector: {
    height: "330px",
    opacity: "0.1",
    [theme.breakpoints.down("md")]: {
      height: "230px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "130px",
    },
  },
  logo: {
    position: "absolute",
    top: "52%",
    [theme.breakpoints.down("ultraHD")]: { top: "42%" },
    left: "-7%",
    opacity: "10%",
    width: "661px",
    height: "661px",
    zIndex: 1,
  },
}));

const AdminLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const adminTeamPaths = [
    routes.adminTeamParticipating,
    routes.adminTeamDetails,
  ];
  const isAdminTeamOwner = adminTeamPaths.includes(location.pathname);
  const isTeamsDashboard = location.pathname === "/teams/dashboard";

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
    navigate(routes.login);
  };

  return (
    <>
      {isMobile ? (
        <Box className={classes.container}>
          <Box className={classes.mobileScreen}>
            <Box
              sx={{
                // height: "40px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <img
                src={Logo}
                style={{ height: "40px", width: "auto" }}
                alt=""
              /> */}
              {/* {!isTeamsDashboard && ( */}
              {/* <Box
                sx={{
                  color: "white",
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "6px 12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                  border: "0.5px solid #696969",
                  borderRadius: "60px",
                }}
                onClick={handleLogout}
              >
                Logout <LogoutIcon sx={{ fontSize: "16px" }} />
              </Box> */}
              {/* )} */}
            </Box>

            <Box
              sx={{ height: "calc(100% - 40px)", overflowY: "scroll", p: 2 }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      ) : (
        <>
          {!isAdminTeamOwner ? (
            <Box className={classes.desktopLayout}>
              <Box className={classes.desktopHeader}>
                <Box className={classes.desktopHeaderContainer}>
                  <img
                    src={mcaLogo}
                    style={{ height: "50px", width: "auto" }}
                    alt="logo"
                  />

                  <Box
                    sx={{
                      color: "black",
                      fontSize: "16px",
                      fontWeight: 500,
                      padding: "13px 32px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: "0.5px solid #696969",
                      borderRadius: "8px",
                      backgroundColor: "#fff",

                      textAlign: "center",
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </Box>
                </Box>
              </Box>
              <Box className={classes.desktopContainer} style={{}}>
                <Box className={classes.desktopScreen}>{children}</Box>
              </Box>
            </Box>
          ) : (
            <Box className={classes.desktopLayout}>
              <Box
                className={classes.desktopHeader}
                style={{
                  background:
                    " linear-gradient(90deg, #203376 0%, #000 49.89%, #203376 101.04%), #161616",
                  position: "relative",
                }}
              >
                <img
                  src={headerBadge}
                  style={{
                    left: 0,
                    width: "fit-content",
                    height: "80px",
                  }}
                  alt="badge"
                />
                <Box className={classes.desktopHeaderContainer}>
                  <Box>
                    <img
                      src={mcaLogo}
                      style={{ height: "50px", width: "auto" }}
                      alt="logo"
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#fff",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        fontStyle: "italic",
                      }}
                    >
                      {formatPathToTitle(location.pathname)}
                    </Typography>
                  </Box>
                  <Box>
                    <img
                      src={mcaI20Logo}
                      style={{ height: "100px", width: "auto" }}
                      alt="logo"
                    />
                  </Box>
                </Box>
              </Box>
              <Box className={classes.desktopContainer}>
                <Box className={classes.adminDesktopScreen}>{children}</Box>
              </Box>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default AdminLayout;
